import { Controller } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import CustomizedDatePicker from "component/customizedDatePicker/customized-date-picker.js";

export default function ProfileDateField({ control, error }) {
  const intl = useIntl();

  return (
    <div className="form-label row">
      <div className="col-lg-4">
        <label>
          <FormattedMessage id="dob" />:
        </label>
      </div>
      <div className="col-lg-8">
        <div
          className={`form-label-container ${error?.message ? "mb-3" : ""}`}
        >
          <Controller
            control={control}
            name="birthDate"
            render={({ field }) => (
              <CustomizedDatePicker
                dateFormat="dd/MM/yyyy"
                placeholderText={intl.formatMessage({
                  id: "select-date",
                })}
                onChange={(e) => field.onChange(e.target.value)}
                value={field.value}
                min={new Date("1900-01-01").toJSON().slice(0, 10)}
                max={new Date().toJSON().slice(0, 10)}
                className={`form-control ${error ? "is-invalid" : ""}`}
              />
            )}
          />
          <span>*</span>
        </div>
        {error?.message && (
          <div role="alert" className="alert alert-danger py-1">
            {error.message}
          </div>
        )}
      </div>
    </div>
  );
}
